import { OidcAccessToken } from "@axa-fr/react-oidc/dist/ReactOidc";
import { ImpersonationRequest } from "./impersonation";

/**
 * Builds standard request headers including authorization and impersonation if active
 */
export function buildRequestHeaders(
  accessToken: OidcAccessToken,
  currentImpersonation?: ImpersonationRequest | null,
): HeadersInit {
  const headers: HeadersInit = {
    Authorization: `Bearer ${accessToken.accessToken}`,
    "Content-Type": "application/json",
  };

  // Add impersonation header if currently impersonating
  if (currentImpersonation) {
    headers["X-Impersonate-User"] = JSON.stringify({
      target_user_id: currentImpersonation.target_user_id,
      target_user_email: currentImpersonation.target_user_email,
      target_user_name: currentImpersonation.target_user_name,
      target_user_groups: currentImpersonation.target_user_groups,
    });
  }

  return headers;
} 